<template>
    <b-card
        no-body
    >
        <div class="card-header">
            <div
                class="card-group-title"
            >
                <h4>{{ $t("org.billing.Detail Cost") }}</h4>
            </div>
        </div>
        <div class="table-responsive">
            <b-table-simple
                v-if="noData"
                no-border-collapse
            >
                <b-thead>
                    <b-tr>
                        <b-th>
                            {{ $t('v4.Value') }}
                        </b-th>
                        <b-th style="width:20%;" class="text-right text-body-headin">
                            {{ $t('v4.Cost') }}
                        </b-th>
                    </b-tr>
                </b-thead>
                <b-tbody>
                    <b-tr>
                        <b-td colspan="2" class="text-center pb-50 pt-2">
                            <div class="d-flex justify-content-center align-items-center flex-column text-center">
                                <SVGEmptyIcon/>
                                <span>{{ $t('org.dashboard.No data') }}</span>
                            </div>
                        </b-td>
                    </b-tr>
                </b-tbody>
            </b-table-simple>
            <b-table-simple
                v-else
                sticky-header="600px"
                no-border-collapse
            >
                <b-thead>
                    <b-tr>
                        <b-th>
                            {{ $t('v4.Value') }}
                        </b-th>
                        <b-th
                            class="text-right"
                            style="width: 20%;"
                        >
                            {{ $t('v4.Cost') }}
                        </b-th>
                    </b-tr>
                </b-thead>
                <b-tbody>
                    <template v-for="(item, index) in data">
                        <b-tr :key="`main-${index}`">
                            <b-td>
                                <b-form-checkbox
                                    v-model="checkboxModels[item.tagValue]"
                                    @change="getCostTagsByCategory(item, index)"
                                >
                                    {{ item.tagValue }}
                                </b-form-checkbox>

                            </b-td>
                            <b-td
                                class="text-right text-nowrap"
                            >
                                {{ $_getDollar(item.cost) }}
                            </b-td>
                        </b-tr>
                        <b-tr :key="`sub-${index}`" v-if="item.showChildren">
                            <b-td colspan="2">
                                <b-card no-body class="mb-0">
                                    <b-row class="mb-0" v-for="(subItem, subIndex) in item.children" :key="subIndex">
                                        <b-col
                                            md="8"
                                            class="mb-1"
                                        >
                                            <a href="javascript:;" @click="getCostTagsByResourceId(subItem, item.tagValue, index, subIndex)">
                                                <strong>
                                                    {{ subItem.productCode }}
                                                </strong>
                                                {{ subItem.productCategory }}
                                            </a>
                                        </b-col>
                                        <b-col md="4" class="text-right">
                                            <b
                                                v-if="subItem.showChildren"
                                            >
                                                Sub Total: {{ $_getDollar(subItem.cost) }}
                                            </b>
                                            <span
                                                v-else
                                            >
                                                {{ $_getDollar(subItem.cost) }}
                                            </span>
                                        </b-col>
                                        <b-col>
                                            <b-collapse v-model="subItem.showChildren">
                                                <b-card-text
                                                    v-for="(resource, resourceIndex) in subItem.children"
                                                    :key="resourceIndex"
                                                    class="mb-1 d-flex justify-content-between"
                                                >
                                                    <span>
                                                        {{ resource.resourceId }}
                                                    </span>
                                                    <span>
                                                        {{ $_getDollar(resource.cost) }}
                                                    </span>
                                                </b-card-text>
                                                <hr v-if="subIndex < item.children.length - 1">
                                            </b-collapse>
                                        </b-col>
                                    </b-row>
                                </b-card>
                            </b-td>
                        </b-tr>
                    </template>
                </b-tbody>
            </b-table-simple>
        </div>
    </b-card>
</template>

<script>
import { computed, toRefs } from '@vue/composition-api'
import SVGEmptyIcon from '@/assets/images/empty.svg'

export default {
    components: {
        SVGEmptyIcon
    },
    props: {
        data: {
            type: Array,
            default: function () {
                return []
            }
        },
        month: {
            type: String
        },
        projectIdx: {
            type: [String, Number]
        },
        tagKey: {
            type: String
        },
        themeColors: {
            type: Object,
            default: function () {
                return {}
            }
        }
    },
    setup (props, context) {
        const { data, month, projectIdx, tagKey } = toRefs(props)
        const checkboxModels = data.value.reduce((acc, cur) => ({ ...acc, [cur.tagValue]: false }), {})
        const noData = computed(() => !data.value.length)
        const getCostTagsByCategory = (item, index) => {
            if (item.showChildren) {
                item.showChildren = !item.showChildren
                return
            }
            context.emit('api:getCostTagsByCategory', {
                projectIdx: projectIdx.value,
                month: month.value,
                tagKey: tagKey.value,
                tagValue: item.tagValue,
                index
            })
        }
        const getCostTagsByResourceId = (subItem, tagValue, rootIndex, index) => {
            if (subItem.showChildren) {
                subItem.showChildren = !subItem.showChildren
                return
            }
            context.emit('api:getCostTagsByResourceId', {
                projectIdx: projectIdx.value,
                month: month.value,
                tagKey: tagKey.value,
                tagValue,
                productCode: subItem.productCode,
                productCategory: subItem.productCategory,
                index,
                rootIndex
            })
        }

        return {
            checkboxModels,
            noData,
            getCostTagsByCategory,
            getCostTagsByResourceId
        }
    }
}
</script>

<style>

</style>
